import React, { useContext, useEffect, useState } from "react";

import { Link as RouterLink } from "react-router-dom";

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EventBusyIcon from "@mui/icons-material/EventBusy";

import { stringToLocaleDateString } from "../../../../helpers";
import { UtenteLink } from "../../../common";
import { NavContext, NavRoutes } from "../../../contexts";
import { UtentiContext } from "../UtentiContext";

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

export const UtentiList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onExport,
    onImport,
    onActionClick,
    ...props
}) => {
    const { getRouteTo } = useContext(NavContext);

    const { state } = useContext(UtentiContext);

    const { utenti } = state;

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    };

    const deleteClickHandler = async (data) => {
        if (onActionClick) onActionClick("Delete", data);
    };

    const addClickHandler = (data) => {
        if (onActionClick) onActionClick("Add", data);
    };

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value);
    };

    useEffect(() => {
        if (utenti && onLoadMore) {
            onLoadMore(0, pageSize, searchText);
        }
    }, [searchText]);

    useEffect(() => {
        if (utenti && onLoadMore) {
            onLoadMore(pageIndex, pageSize, searchText);
        }
    }, [pageIndex, pageSize]);

    return (
        <div>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}
            >
                {utenti ? utenti.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card>
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography variant="h6">Tutti gli Utenti</Typography>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    disabled={disabled}
                                    onClick={addClickHandler}
                                >
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue" }}>
                            <TableRow>
                                <TableCell style={{ width: "25%" }}>Nominativo</TableCell>
                                <TableCell style={{ width: "25%" }}>Codice fiscale</TableCell>
                                <TableCell style={{ width: "20%" }}>Ruolo</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {utenti &&
                                utenti.result.length > 0 &&
                                utenti.result.map((utente, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Utente, [utente.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}
                                                        >
                                                            {utente.nome} {utente.cognome}
                                                            {[
                                                                utente.fineValidita,
                                                            ].some((x) => x && x <= new Date()) && (
                                                                    <EventBusyIcon
                                                                        color={
                                                                            "error"
                                                                        }
                                                                    />
                                                                )}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {utente.codiceFiscale}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {utente.ruolo.nome}
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={utente?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={utente?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(utente.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(utente.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(utente)}
                                                >
                                                    <Tooltip title="disabilita utente">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={utenti ? utenti.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
};
